import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconUserMale = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 24 24'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M22.267,24.000 L1.733,24.000 C0.778,24.000 0.000,23.222 0.000,22.266 L0.000,20.799 C0.000,20.448 0.184,20.123 0.485,19.942 L7.355,15.819 C5.030,13.219 5.000,9.728 5.000,9.563 L5.003,5.282 C5.003,5.224 5.008,5.166 5.019,5.108 C5.561,2.052 9.066,-0.000 12.000,-0.000 C12.001,-0.000 12.003,-0.000 12.005,-0.000 C14.937,-0.000 18.439,2.051 18.981,5.106 C18.992,5.164 18.997,5.222 18.997,5.280 L19.000,9.561 C19.000,9.727 18.970,13.219 16.645,15.819 L23.515,19.940 C23.816,20.120 24.000,20.446 24.000,20.797 L24.000,22.266 C24.000,23.222 23.222,24.000 22.267,24.000 ZM22.000,21.365 L14.484,16.854 C14.397,16.802 14.333,16.729 14.268,16.657 C14.250,16.637 14.224,16.630 14.207,16.608 C14.205,16.604 14.204,16.600 14.202,16.596 C14.148,16.525 14.119,16.443 14.086,16.362 C14.070,16.322 14.042,16.286 14.031,16.245 C14.015,16.182 14.023,16.117 14.019,16.052 C14.015,15.989 14.001,15.926 14.009,15.864 C14.015,15.820 14.039,15.780 14.051,15.738 C14.073,15.654 14.093,15.570 14.137,15.494 C14.140,15.490 14.139,15.486 14.142,15.482 C14.175,15.426 14.226,15.391 14.267,15.344 C14.308,15.298 14.337,15.244 14.388,15.205 C16.975,13.208 17.000,9.600 17.000,9.563 L16.997,5.376 C16.622,3.598 14.269,1.998 12.000,1.998 C9.731,1.999 7.378,3.601 7.003,5.378 L7.000,9.564 C7.000,9.598 7.046,13.223 9.612,15.205 C9.664,15.245 9.694,15.300 9.736,15.347 C9.776,15.393 9.826,15.428 9.858,15.482 C9.861,15.486 9.861,15.491 9.863,15.495 C9.906,15.570 9.926,15.653 9.948,15.735 C9.960,15.779 9.985,15.820 9.991,15.864 C9.999,15.924 9.984,15.985 9.981,16.046 C9.978,16.113 9.985,16.180 9.969,16.245 C9.958,16.285 9.931,16.320 9.916,16.358 C9.883,16.441 9.852,16.524 9.798,16.597 C9.795,16.600 9.795,16.604 9.792,16.608 C9.755,16.656 9.704,16.683 9.660,16.722 C9.612,16.766 9.574,16.819 9.516,16.854 L2.000,21.365 L2.000,22.000 L22.000,22.000 L22.000,21.365 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconUserMale.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
